// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateCompanyAppeal_paper__AYqcj {
  width: 460px;
  max-width: 100%;
  padding-bottom: 30px;
  overflow-x: hidden;
}

.CreateCompanyAppeal_header__hSF58 {
  position: relative;
  display: flex;
  justify-content: center;
  padding: 0 24px;
}

.CreateCompanyAppeal_image__KuuV2 {
  max-width: 100%;
  height: 200px;
  margin: 24px auto 16px;
}

.CreateCompanyAppeal_title__1Y9Fa {
  padding-top: 0px !important;
  padding-bottom: 16px !important;
}

.CreateCompanyAppeal_content__\\+QHkl {
  padding: 0 24px;
}

.CreateCompanyAppeal_description__H2-Kx {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #272A36;
  margin-bottom: 20px;
}

.CreateCompanyAppeal_note__Q8SWL {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #8E8E93;
}

.CreateCompanyAppeal_actions__E9OXr {
  padding: 10px 24px 10px;
  display: flex;
  flex-direction: column;
  align-content: stretch;
}
.CreateCompanyAppeal_actions__E9OXr > * {
  margin-bottom: 16px;
}

.CreateCompanyAppeal_close__W1qbl {
  display: inline-flex;
  align-content: center;
  justify-content: center;
  flex-wrap: wrap;
  cursor: pointer;
  width: 70px;
  height: 70px;
  position: absolute;
  top: 0;
  right: 0;
  border: 0;
  background: transparent;
  transform: rotate(0deg);
  transition: 0.3s all;
}
.CreateCompanyAppeal_close__W1qbl:hover {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/components/modals/CreateCompanyAppeal/CreateCompanyAppeal.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,2BAAA;EACA,+BAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AACF;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,oBAAA;EACA,qBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EAEA,uBAAA;EACA,oBAAA;AAFF;AAIE;EACE,yBAAA;AAFJ","sourcesContent":[".paper {\n  width: 460px;\n  max-width: 100%;\n  padding-bottom: 30px;\n  overflow-x: hidden;\n}\n\n.header {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  padding: 0 24px;\n}\n\n.image {\n  max-width: 100%;\n  height: 200px;\n  margin: 24px auto 16px;\n}\n\n.title {\n  padding-top: 0px !important;\n  padding-bottom: 16px !important;\n}\n\n.content {\n  padding: 0 24px;\n}\n\n.description {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19px;\n  color: #272A36;\n  margin-bottom: 20px;\n}\n\n.note {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19px;\n  color: #8E8E93;\n}\n\n.actions {\n  padding: 10px 24px 10px;\n  display: flex;\n  flex-direction: column;\n  align-content: stretch;\n\n  &>* {\n    margin-bottom: 16px;\n  }\n}\n\n.close {\n  display: inline-flex;\n  align-content: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  cursor: pointer;\n\n  width: 70px;\n  height: 70px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  border: 0;\n  background: transparent;\n\n  transform: rotate(0deg);\n  transition: 0.3s all;\n\n  &:hover {\n    transform: rotate(180deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `CreateCompanyAppeal_paper__AYqcj`,
	"header": `CreateCompanyAppeal_header__hSF58`,
	"image": `CreateCompanyAppeal_image__KuuV2`,
	"title": `CreateCompanyAppeal_title__1Y9Fa`,
	"content": `CreateCompanyAppeal_content__+QHkl`,
	"description": `CreateCompanyAppeal_description__H2-Kx`,
	"note": `CreateCompanyAppeal_note__Q8SWL`,
	"actions": `CreateCompanyAppeal_actions__E9OXr`,
	"close": `CreateCompanyAppeal_close__W1qbl`
};
export default ___CSS_LOADER_EXPORT___;
